export default {
  data () {
    return {
      dataMixinGiftsReportProjectFields: [
        {
          label: 'Player ID',
          key: 'player_id',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th',
          thStyle: { width: '15%' }
        },
        {
          label: 'Task ID',
          key: 'task_id',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { width: '15%' }
        },
        {
          label: 'Gift',
          key: 'description',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action',
          thStyle: { width: '80px' }
        }
      ]
    };
  }
};
